<template>
  <v-card class="mx-auto pa-0" height="160" width="330" @click="$emit('click')">
    <v-row class="ma-0 pt-1" justify="space-between">
      <v-col cols="4" sm="5">
        <v-img height="128" width="128" :src="data.icon" contain></v-img>
      </v-col>
      <v-col cols="8" sm="7">
        <v-card-text>
          <v-row>
            <div class="_grey--text text-h6 text-truncate" style="max-width: 140px">{{ data.name }}</div>
          </v-row>
          <v-row>
            <div class="_grey--text caption text-truncate" style="max-width: 140px">{{ data.publisherName }}</div>
          </v-row>
          <v-row class="mt-10 mt-sm-14" justify="space-between">
            <v-rating :value="data.rating" color="_grey" background-color="_grey" dense half-increments readonly size="12"></v-rating>
            <div v-if="!discount.exist" class="_blue--text" style="font-size: 12px">NT${{ price(data.price) }}{{ unit(data.price) }}</div>
            <div v-else class="_blue--text text-decoration-line-through" style="font-size: 12px">
              NT${{ price(data.price) }}{{ unit(data.price) }}
            </div>
          </v-row>
          <v-row v-show="discount.exist" justify="space-between">
            <div class="red--text" style="font-size: 12px">{{ discountPeriod }}</div>
            <div class="red--text" style="font-size: 12px">NT${{ price(discount.price) }}{{ unit(discount.price) }}</div>
          </v-row>
        </v-card-text>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import Product from '../store/product';

export default {
  name: 'CardH',
  props: {
    data: { type: Object, required: true },
  },
  data: () => ({
    discount: {},
  }),
  computed: {
    discountPeriod() {
      return Product.discountPeriod();
    },
  },
  created() {
    this.discount = Product.discountProc(this.data.discountPeriod, this.data.discount);
  },
  methods: {
    price(price) {
      return Product.price(price);
    },
    unit(price) {
      return this.$t(Product.unit(price));
    },
  },
};
</script>
